import { render, staticRenderFns } from "./ReferralsPatientDetailsModal.vue?vue&type=template&id=697a02bc&scoped=true"
import script from "./ReferralsPatientDetailsModal.vue?vue&type=script&lang=js"
export * from "./ReferralsPatientDetailsModal.vue?vue&type=script&lang=js"
import style0 from "./ReferralsPatientDetailsModal.vue?vue&type=style&index=0&id=697a02bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "697a02bc",
  null
  
)

export default component.exports